// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BuildCard.css */
.build-card {
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  width: 300px; /* Adjust width as needed */
  text-align: center;
  cursor: pointer;
  transition: transform 0.3s, box-shadow 0.3s;
  margin: 0.625em;
  padding: 1.25em;
  position: relative;
}

.build-card:hover {
  transform: scale(1.05);
  box-shadow: 0 0.25em 0.5em rgba(0, 0, 0, 0.2);
}

.build-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.625em;
}
.build-card-title-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.build-card-title {
  flex: 1 1;
  text-align: left;
  font-size: 1.4em;
  font-family: "Fivo Sans Medium", sans-serif;
  color: #333;
}
.quote-build-button {
  background-color: #007bff;
  border: none;
  color: white;
  padding: 5px 10px;
  cursor: pointer;
  border-radius: 5px;
  margin-left: 10px;
}

.quote-build-button:hover {
  background-color: #0056b3;
}

.market-image-container {
  position: relative;
  text-align: center;
  color: white;
}

.market-image {
  width: 100%;
  height: auto;
  border-radius: 10px;
}

.edit-build-button {
  position: absolute;
  top: 10px;
  left: 10px;
  background-color: #28a745;
  color: white;
  border: none;
  padding: 5px 5px;
  cursor: pointer;
  border-radius: 15px;
}

.edit-build-button:hover {
  background-color: #218838;
}

.edit-build-name-input {
  width: 100px;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-right: 5px;
}

.save-name-button {
  background-color: #28a745;
  border: none;
  color: white;
  padding: 5px 10px;
  cursor: pointer;
  border-radius: 5px;
}

.save-name-button:hover {
  background-color: #218838;
}

.build-summary {
  text-align: left;
  margin-top: 10px;
}

.build-summary-item {
  margin-bottom: 10px;
  font-size: 0.9em;
  font-family: "Fivo Sans Regular", sans-serif;
}
.build_creation-date {
  font-family: "Fivo Sans Medium", sans-serif;
  color: #666;
}
.quote-status {
  color: green;
  font-family: "Fivo Sans Medium", sans-serif;
}

.quote-sent-icon {
  color: white;
  font-size: 1em;
}

.quote-message-container {
  margin-top: 10px;
}

.quote-message-textarea {
  width: 100%;
  height: 50px;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
  resize: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/YourCreations/BuildCard.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,uBAAuB;EACvB,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;EAChB,YAAY,EAAE,2BAA2B;EACzC,kBAAkB;EAClB,eAAe;EACf,2CAA2C;EAC3C,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;EAC3C,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,4CAA4C;AAC9C;AACA;EACE,2CAA2C;EAC3C,WAAW;AACb;AACA;EACE,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd","sourcesContent":["/* BuildCard.css */\n.build-card {\n  background-color: white;\n  border-radius: 10px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  width: 300px; /* Adjust width as needed */\n  text-align: center;\n  cursor: pointer;\n  transition: transform 0.3s, box-shadow 0.3s;\n  margin: 0.625em;\n  padding: 1.25em;\n  position: relative;\n}\n\n.build-card:hover {\n  transform: scale(1.05);\n  box-shadow: 0 0.25em 0.5em rgba(0, 0, 0, 0.2);\n}\n\n.build-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.625em;\n}\n.build-card-title-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n.build-card-title {\n  flex: 1;\n  text-align: left;\n  font-size: 1.4em;\n  font-family: \"Fivo Sans Medium\", sans-serif;\n  color: #333;\n}\n.quote-build-button {\n  background-color: #007bff;\n  border: none;\n  color: white;\n  padding: 5px 10px;\n  cursor: pointer;\n  border-radius: 5px;\n  margin-left: 10px;\n}\n\n.quote-build-button:hover {\n  background-color: #0056b3;\n}\n\n.market-image-container {\n  position: relative;\n  text-align: center;\n  color: white;\n}\n\n.market-image {\n  width: 100%;\n  height: auto;\n  border-radius: 10px;\n}\n\n.edit-build-button {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  background-color: #28a745;\n  color: white;\n  border: none;\n  padding: 5px 5px;\n  cursor: pointer;\n  border-radius: 15px;\n}\n\n.edit-build-button:hover {\n  background-color: #218838;\n}\n\n.edit-build-name-input {\n  width: 100px;\n  padding: 5px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  margin-right: 5px;\n}\n\n.save-name-button {\n  background-color: #28a745;\n  border: none;\n  color: white;\n  padding: 5px 10px;\n  cursor: pointer;\n  border-radius: 5px;\n}\n\n.save-name-button:hover {\n  background-color: #218838;\n}\n\n.build-summary {\n  text-align: left;\n  margin-top: 10px;\n}\n\n.build-summary-item {\n  margin-bottom: 10px;\n  font-size: 0.9em;\n  font-family: \"Fivo Sans Regular\", sans-serif;\n}\n.build_creation-date {\n  font-family: \"Fivo Sans Medium\", sans-serif;\n  color: #666;\n}\n.quote-status {\n  color: green;\n  font-family: \"Fivo Sans Medium\", sans-serif;\n}\n\n.quote-sent-icon {\n  color: white;\n  font-size: 1em;\n}\n\n.quote-message-container {\n  margin-top: 10px;\n}\n\n.quote-message-textarea {\n  width: 100%;\n  height: 50px;\n  padding: 5px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  resize: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
